/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Summary_TitleInputs */

const en_pdf_cv_review_summary_title = /** @type {(inputs: Pdf_Cv_Review_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV Review - Summary`)
};

const de_pdf_cv_review_summary_title = /** @type {(inputs: Pdf_Cv_Review_Summary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-Bewertung - Zusammenfassung`)
};

/**
* | output |
* | --- |
* | "CV Review - Summary" |
*
* @param {Pdf_Cv_Review_Summary_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_summary_title = /** @type {((inputs?: Pdf_Cv_Review_Summary_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Summary_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_summary_title(inputs)
	return en_pdf_cv_review_summary_title(inputs)
});